import { useEffect, useState } from 'react'

// locals
import MeetingRoomService from 'service/MeetingRoomService'
import { IGetMeetingRoomTimeTableList } from 'types/MeetingRoomType'
import DateUtil from 'utils/DateUtil'
import { groupBy } from 'utils/Miscellaneous'

export default function useGetMeetingRoomResTable(
  locationId: number,
  meetingRoomId: number,
  dateFromList: Date,
  isCalendar: boolean = false
) {
  const [timeTable, setTimeTable] = useState<IGetMeetingRoomTimeTableList[] | []>([])
  const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
  const [tableWeek, setTableWeek] = useState(selectedDate)
  const [availableDates, setAvailableDates] = useState({ start: 0, end: 0 })
  const [selectedReservations, setSelectedReservations] = useState<IGetMeetingRoomTimeTableList[]>()
  const [sidebarVisible, setSidebarVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    MeetingRoomService.getMeetingRoomDetailByLocationId(locationId)
      .then((res) =>
        setAvailableDates({
          start: res.data.reservationStartDay,
          end: res.data.reservationEndDay,
        })
      )
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }, [locationId])

  useEffect(() => {
    setLoading(true)
    MeetingRoomService.getMeetingRoomReservationTableList({
      meetingRoomId: meetingRoomId,
      startDate: DateUtil.formatDateToString(tableWeek.start),
      endDate: DateUtil.formatDateToString(tableWeek.end),
    })
      .then((res) => setTimeTable(res.data))
      .finally(() => setLoading(false))

    /* Reset selected appointment time */
    if (!isCalendar) setSelectedReservations(undefined)
  }, [meetingRoomId, tableWeek.start, tableWeek.end, isCalendar])

  useEffect(() => {
    const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
    setTableWeek(selectedDate)
  }, [dateFromList, meetingRoomId])

  const dailyAppointments: [] | Record<string, IGetMeetingRoomTimeTableList[]> = !!timeTable.length
    ? groupBy(timeTable, (v) => DateUtil.formatStringToDate(v.reservationStartHour))
    : []

  return {
    availableDates,
    tableWeek,
    setTableWeek,
    selectedReservations,
    setSelectedReservations,
    sidebarVisible,
    setSidebarVisible,
    dailyAppointments,
    loading,
  }
}
